"use strict";

exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.13.2@element-ui/lib/mixins/focus.js
// module id = 188
// module chunks = 0